module.exports = __webpack_public_path__ + "static/media/street-art-02.ceab0767.png";